import { render, staticRenderFns } from "./LoadingPlaceEditor.vue?vue&type=template&id=5804d07f"
import script from "./LoadingPlaceEditor.vue?vue&type=script&lang=js"
export * from "./LoadingPlaceEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports